// extracted by mini-css-extract-plugin
export default {"root":"qDSBo2","row":"lp1vfd","date":"AgwTCB","total":"fJoXeo","arrow":"gGxLR3"};